import useConfig from '@sdk/config/useConfig';
import useAuth from '@sdk/authentication/useAuth';
import { isFeatureEnabled } from '@sdk/utils/isFeatureEnabled';

const useIsAutomatedBreaksFeatureFlagEnabled = () => {
  const {
    FEATURE_FLAGS: { AUTOMATED_BREAKS },
  } = useConfig();

  const { currentUser } = useAuth();

  return isFeatureEnabled(AUTOMATED_BREAKS, currentUser.org.id);
};

export default useIsAutomatedBreaksFeatureFlagEnabled;
